import { render, staticRenderFns } from "./lawyers-sent-info.vue?vue&type=template&id=502754bc"
import script from "./lawyers-sent-info.vue?vue&type=script&lang=js"
export * from "./lawyers-sent-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports